import React from 'react';

const BaseSheet = ({
  className = null,
  scrollx = false,
  scrolly = false,
  children,
  ...props
}, ref) => {
  const classes = ['Sheet'];
  classes.push(className);
  if (scrollx) {
    classes.push('scrollx');
  }
  if (scrolly) {
    classes.push('scrolly');
  }
  return <div ref={ref} className={classes.join(' ')} {...props}>
    {children}
  </div>;
};

export const Sheet = React.forwardRef((props, ref) => BaseSheet(props, ref));

export default Sheet;
